import React, { useState } from 'react';

const AccordionItem = ({ title, content, isActive, onClick }) => {
  return (
    <div className="border border-gray-200 mb-4" style={{ borderRadius: 32 }}>
      <button
        className="flex justify-between items-center w-full p-4 focus:outline-none"
        onClick={onClick}
      >
        <span className="text-lg font-semibold">{title}</span>
        <svg
          className={`h-4 w-4 transition-transform ${isActive ? 'transform rotate-180' : 'transform rotate-180'}`}
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d={isActive ? 'M19 9l-7 7-7-7' : 'M5 15l7-7 7 7'}
          />
        </svg>
      </button>
      {isActive && <div className="p-4 text-justify">{content}</div>}
    </div>
  );
};

const Accordion = ({ items }) => {
  const [activeIndex, setActiveIndex] = useState(null);

  const handleClick = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  return (
    <div>
      {items.map((item, index) => (
        <AccordionItem
          key={index}
          title={item.title}
          content={item.content}
          isActive={index === activeIndex}
          onClick={() => handleClick(index)}
        />
      ))}
    </div>
  );
};

export default Accordion;
